import React from 'react';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import ProductCard from './product-card'

const FeaturedProducts = (props) => {
  const { custoObjectInfo } = props;

  let textInfoCustoObjectInfo1 = null;
  if (custoObjectInfo) {
    textInfoCustoObjectInfo1 =custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-1',
    })
  }

  return (
      <div style={{ backgroundColor: '#f5f5f5'}}>
        <div className="container">
          <div className="FeaturedProducts">
            {props['TextInfo-1'] && (
              <TextInfo  {...props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />
            )}
            <div className="ProductList">
              {props['ProductCard-1'] && (
                <ProductCard
                  {...props['ProductCard-1']}
                  custoObjectInfo={custoObjectInfo ? custoObjectInfo.addEntryPoint({
                    custoObjectInfo,
                    entryPoint: 'ProductCard-1',
                  }):null} 
                />
              )}
              {props['ProductCard-2'] && (
                <ProductCard
                  {...props['ProductCard-2']}
                  custoObjectInfo={custoObjectInfo ? custoObjectInfo.addEntryPoint({
                    custoObjectInfo,
                    entryPoint: 'ProductCard-2',
                  }): null}                 
                />
              )}
              {props['ProductCard-3'] && 
                (<ProductCard
                  {...props['ProductCard-3']}
                  custoObjectInfo={custoObjectInfo ? custoObjectInfo.addEntryPoint({
                    custoObjectInfo,
                    entryPoint: 'ProductCard-3',
                  }): null}                    
                />
              )}
              
            </div>
          </div>
        </div>
        <style jsx>
          {`
          .FeaturedProducts {
            display: flex;
            flex-wrap: nowrap;
            flex-direction:column;
            justify-content: space-between;
            align-items: stretch;
            padding: 2rem 0px 2rem 0px;
            height: auto;
            .ProductList {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin-top: 2rem;
            }
          }
          @media screen and (max-width:980px) {
            .FeaturedProducts {
              .ProductList{
                flex-wrap: wrap;
              }
            }
          }
          `}
          </style>
      </div>
    )
}


export default FeaturedProducts;